export default __webpack_public_path__ + "static/media/settings.7e2bf55b.svg";